/* eslint-disable */

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    PoolData: {
      UserPoolId: "us-west-2_gNcqEPh9r",
      ClientId: "6getmssqgur2c18eg7ij2jke4q"
    },
    IdentityPoolData: {
      DeveloperIdentityPoolId: "us-west-2:bbd14359-1ac6-4353-8ad5-89009a302dcc",
      LoginARN: "cognito-idp.us-west-2.amazonaws.com/us-west-2_gNcqEPh9r"
    },
    UserPool: "",
    UserName: "",
    AccessGroups: "",
    IdToken: "",
    CognitoUser: "",
    UserObject: null,
    CompanyMap: null,
    SingleCompanyUser: null
  },

  mutations: {
    saveUserPool(state, userpool) {
      state.UserPool = userpool;
    },
    saveUserName(state, username) {
      state.UserName = username;
    },
    saveIdToken(state, idtoken) {
      state.IdToken = idtoken;
    },
    saveAccessGroups(state, groups) {
      state.AccessGroups = groups;
    },
    saveCognitoUser(state, user) {
      state.CognitoUser = user;
    },
    saveUserObject(state, object) {
      state.UserObject = object;
    },
    saveCompanyMap(state, map) {
      state.CompanyMap = map;
    },
    saveSingleCompanyUser(state, value) {
      state.SingleCompanyUser = value;
    }
  }
});
